import React from 'react'
import { Box } from '@node-space/ui-components'

interface PayloadViewProps {
  jsonString: string
}

export const PayloadView = ({ jsonString }: PayloadViewProps) => {
  return (
    <Box flex flexCol width="full" className="max-h-[400px] rounded-lg ">
      <pre className="rounded-lg  flex-1 overflow-auto whitespace-pre-wrap break-words font-mono text-xs p-4 text-left bg-surface-inverse text-foreground-action-inverse">
        {jsonString}
      </pre>
    </Box>
  )
}
